import { Widget } from "blue-widgets";
import debounce from "../tools/debounce";

class Header extends Widget {
  constructor(el) {
    super(el);

    this.setHeaderHeightVar = this.setHeaderHeightVar.bind(this);

    this.init();

    window.addEventListener("resize", () => {
      debounce(this.setHeaderHeightVar, 300);
    });
  }

  init() {
    this.setHeaderHeightVar();
  }

  setHeaderHeightVar() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.el.offsetHeight}px`
    );
  }

  beforeRemove() {
    window.removeEventListener("resize", this.setHeaderHeightVar, 300);
  }
}

export default Header;
